// extracted by mini-css-extract-plugin
export default {"chip_list":"ChipList_chip_list__6qtnj"};